import { createSelector } from '@ngrx/store';
import { IgenomicsState } from '@ispm/core/interfaces/genomics-state.interface';

const selectFormdatabinding = (state: IgenomicsState) => state.forms.dataBindings;

export const getFormComfigByName = (name: string) => createSelector(selectFormdatabinding, (allFormsConfig) => {
  if (allFormsConfig) {
    return allFormsConfig[name];
  } else {
    return { };
  }
});
